<template>
  <sec-section labelledby="about-built" :divider="false">
    <sec-split side heading-id="about-built" :eyebrow="built.eyebrow" :title="built.title">
      <sec-plain-list size="lg" :items="built.items" />
    </sec-split>
  </sec-section>
</template>

<script setup>
import SecSection from '@/components/security/ui/SecSection.vue';
import SecSplit from '@/components/security/ui/SecSplit.vue';
import SecPlainList from '@/components/security/ui/SecPlainList.vue';
import { ABOUT } from '@/content/security/about';

const built = ABOUT.howWeAreBuilt;
</script>
